import { render } from "./DCTDashboardView.vue?vue&type=template&id=728a531a&scoped=true"
import script from "./DCTDashboardView.vue?vue&type=script&lang=js"
export * from "./DCTDashboardView.vue?vue&type=script&lang=js"

import "./DCTDashboardView.vue?vue&type=style&index=0&id=728a531a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728a531a"]])

export default __exports__